module.exports = __webpack_public_path__ + "fo.c5b79cc205bd974fe353.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/fo.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/fo.svg
// module chunks = styles